import { render, staticRenderFns } from "./lsdocs4.vue?vue&type=template&id=46687fc8&scoped=true"
import script from "./lsdocs4.vue?vue&type=script&lang=js"
export * from "./lsdocs4.vue?vue&type=script&lang=js"
import style0 from "./lsdocs4.vue?vue&type=style&index=0&id=46687fc8&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46687fc8",
  null
  
)

export default component.exports